import React from "react";
import { motion } from "framer-motion";
import { IMAGES, CONFIG } from "../data/content";
import { Reveal, Eyebrow, EASE } from "./Reveal";

export const About = () => (
  <section
    id="about"
    className="relative bg-[#F4EBD9] py-24 sm:py-36 px-6 sm:px-10 md:px-16"
    data-testid="about"
  >
    <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 md:gap-20 items-start">
      <Reveal className="relative md:sticky md:top-28">
        <div className="absolute -top-6 -left-6 w-full h-full arch border border-[#CBA135]/50 -z-0" />
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="relative z-10 overflow-hidden arch rounded-b-3xl shadow-2xl"
        >
          <img
            src={IMAGES.portrait}
            alt={`${CONFIG.founder}, Spiritual Practitioner & Mentor`}
            className="w-full h-[440px] sm:h-[600px] object-cover"
          />
        </motion.div>
      </Reveal>

      <div>
        <Reveal>
          <Eyebrow className="text-[#9C7526]">About Me</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-serif font-medium text-[#21070D] text-4xl sm:text-5xl lg:text-6xl leading-[1.03] tracking-tight">
            I'm {CONFIG.founder}, a Spiritual Practitioner &amp; Mentor devoted to
            helping people reconnect with their inner power, inner calling, and
            deeper spiritual path.
          </h2>
        </Reveal>
        <div className="mt-8 space-y-5 text-[#3A1219] text-lg sm:text-xl leading-relaxed body-serif border-l-2 border-[#CBA135]/60 pl-6">
          <Reveal delay={0.12}>
            <p>
              My journey began with a deep soul calling to guide those who felt
              lost on their spiritual path. With the grace and blessings of my
              revered Guru, Om Swamiji, and Ma Lalita, I have been walking the
              path of Sri Vidhya, dedicating myself to sadhana, spiritual growth,
              and service.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <p>
              As I continue to move forward on the sacred path of Sri Vidhya, with
              the grace of my Guru and Ma Lalita, I am deepening my own spiritual
              journey while guiding and supporting others on theirs.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p>
              My purpose has never been just to share spiritual knowledge, but to
              offer practical wisdom that people can apply in their own lives. I
              believe that every individual has the power to shape their own
              reality, and my mission is to help people realise their true
              potential and become the author of their own story.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <p>
              Through Tarot, energy healing, spiritual guidance, and ancient
              wisdom, I strive to empower souls to heal, grow, and align with their
              highest path.
            </p>
          </Reveal>
          <Reveal delay={0.28}>
            <p>
              With the blessings of my Guru and Ma Lalita, I continue to walk this
              sacred path of Sri Vidhya — learning, evolving, and guiding others
              towards greater clarity, inner healing, spiritual growth, and
              alignment with their highest self.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
